import request from '../requestPB'
import { SERVER_DOMAIN, OPEN_SERVER_DOMAIN ,AISERVICE_DOMAIN, CUSTOMS_DOMAIN, EX_DOMAIN } from '../constant'

// 京东挂签需求报告 POST api/v1/appraisal/hangtagreport
export const fetchAppraisalJDReport = (data) => {
  console.log(data, 'data')
  return request({
    url: `${CUSTOMS_DOMAIN}/api/v1/appraisal/hangtagreport`,
    method: 'POST',
    data
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.HangTagReportRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.HangTagReportResponse',
    TOKEN_REQUIRED: false,
    ERROR_ACTION: 'toast',
    httpAddress: 'customs',
  })
}

// 高拍仪挂签需求报告 POST api/v1/video_detection/report
export const fetchAppraisalGpyReport = (data) => {
  console.log(data, 'data')
  return request({
    url: `${EX_DOMAIN}/api/v1/video_detection/report`,
    method: 'POST',
    data
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.VideoDetectionReportRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.VideoDetectionReportResponse',
    TOKEN_REQUIRED: false,
    ERROR_ACTION: 'toast',
    httpAddress: 'ex',
  })
}

// 序列码查询鉴定报告详情  POST /appraisal/api/v1/admin/appraisalReport
export const fetchAppraisalReportDetailV2 = ({serialNum}) => {
  console.log(serialNum);
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/admin/appraisalReport`,
    method: 'POST',
    data: {serialNum}
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAIServiceCommonReportRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAIServiceCommonReportResponse',
    TOKEN_REQUIRED: false,
    ERROR_ACTION: 'toast'
  })
}
// v2-查询鉴定报告详情  POST /taggedOrder/report 
export const fetchAppraisalReportDetail = ({OAID}) => {
  console.log(OAID);
  return request({
    url: `${SERVER_DOMAIN}/taggedOrder/report`,
    method: 'POST',
    data: {OAID}
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAIServiceGenAppraisalReportRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAIServiceGenAppraisalReportResponse',
    TOKEN_REQUIRED: false,
    ERROR_ACTION: 'toast'
  })
}
// ccic-查询鉴定报告详情  POST /aiservice/appraisalReport
export const fetchCCICReportDetail = ({OAID}) => {
  console.log(OAID);
    return request({
      url: `${OPEN_SERVER_DOMAIN}/aiservice/appraisalReport`,
      method: 'POST',
      data: {OAID}
    }, {
      PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSOPAppraisalReportRequest',
      PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSOPAppraisalReportResponse',
      TOKEN_REQUIRED: false,
      ERROR_ACTION: 'toast',
      httpAddress: 'open',
    })
}
  
export const fetchZpReportDetail = ({OAID}) => {
  console.log(OAID);
    return request(
      {
        url: `${OPEN_SERVER_DOMAIN}/aiservice/appraisalReportV2`,
        method: "POST",
        data: { OAID },
      },
      {
        PB_LOOK_TYPE_PATH_REQUEST: "proto.TSOPAppraisalReportRequest",
        PB_LOOK_TYPE_PATH_RESPONSE: "proto.TSOPAppraisalReportResponse",
        TOKEN_REQUIRED: false,
        ERROR_ACTION: "toast",
        httpAddress: "open",
      }
    );
  }

export const fetchWpReportDetail = ({OAID}) => {
  console.log(OAID);
    return request(
      {
        url: `${OPEN_SERVER_DOMAIN}/aiservice/report/wp`,
        method: "POST",
        data: { OAID },
      },
      {
        PB_LOOK_TYPE_PATH_REQUEST: "proto.TSOPAppraisalReportRequest",
        PB_LOOK_TYPE_PATH_RESPONSE: "proto.TSOPAppraisalReportResponse",
        TOKEN_REQUIRED: true,
        ERROR_ACTION: "toast",
        httpAddress: "open",
      }
    );
  }

  // 获取小程序码 POST  /public/WXAppletCode
export const getMainPic = ({scene, page}) => {
  return request({
    url: `${SERVER_DOMAIN}/public/WXAppletCode`,
    method: 'POST',
    data: {scene, page}
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSPublicWXAppletCodeRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSPublicWXAppletCodeResponse',
    // TOKEN_REQUIRED: true,
    // ERROR_ACTION: 'toast'
  })
}

//  付费鉴定订单详情 /taggedOrder/result
export const getOrderDetail = (data) => {
  console.log(data);
  return request({
    url: `${SERVER_DOMAIN}/taggedOrder/result`,
    data: data,
    method: 'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraisalOrderDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraisalOrderDetailResponse',
    ERROR_ACTION: 'message',
  })
}

//////////////////////////////////////////////////////////
//           h5 外包鉴定师登陆 字节二期需求               //
//////////////////////////////////////////////////////////

//鉴定师登录  /manual/api/v1/appraiser/login
export const apiAppraiserLogin =(data)=>{
  return request({
    url: `${AISERVICE_DOMAIN}/manual/api/v1/appraiser/login`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSManualAppraiserLoginRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSManualAppraiserLoginResponse',
    ERROR_ACTION: 'message',
    APPRAISERTOKEN_REQUIRED: false,
  })
}

//获取鉴定订单详情信息 @token_required /manual/api/v1/appraiser/detail
export const apiGetAppraisalOrderDetailInfo =(data)=>{
  return request({
    url: `${AISERVICE_DOMAIN}/manual/api/v1/appraiser/detail`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSManualAppraiserDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSManualAppraiserDetailResponse',
    ERROR_ACTION: 'toast',
    APPRAISERTOKEN_REQUIRED: true,
  })
}

//获取鉴定订单详情信息 @token_required /appraisal/api/v1/appraiser/detail
export const apiGetCheckOrderDetailInfo =(data)=>{
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/appraiser/detail`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraisalAppraiserDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraisalAppraiserDetailResponse',
    ERROR_ACTION: 'toast',
    REVIEWTOKEN_REQUIRED: true,
  })
}

//提交复核 @token_required /appraisal/api/v1/appraiser/recheck
// uint32 reAppraisalResult = 2; // 整鉴复核结果 1-真 2-假 3-无法鉴别
export const apiSubmitCheckOrder =(data)=>{
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/appraiser/recheck`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraisalAppraiserRecheckRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraisalAppraiserRecheckResponse',
    ERROR_ACTION: 'toast',
    REVIEWTOKEN_REQUIRED: true,
  })
}

//提交鉴定结果  @token_required  /manual/api/v1/appraiser/result
export const apiSubmitAppraisalResult=(data)=>{
  return request({
    url: `${AISERVICE_DOMAIN}/manual/api/v1/appraiser/result`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSManualAppraiserResultRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSManualAppraiserResultResponse',
    ERROR_ACTION: 'toast',
    APPRAISERTOKEN_REQUIRED: true,
  })
}

// 登陆 POST  /appraisal/api/v1/appraiser_login
export const appraiser_login = (data) => {
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/appraiser_login`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraiserLoginRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraiserLoginResponse',
    ERROR_ACTION: 'toast',
    APPRAISERTOKEN_REQUIRED: true,
  })
}

// AI鉴定订单详情 POST @token_required /appraisal/api/v1/appraisal_info
export const appraisal_info = (data) => {
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/appraisal_info`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraisalInfoRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraisalInfoResponse',
    ERROR_ACTION: 'toast',
    APPRAISERTOKEN_REQUIRED: true,
  })
}

// 鉴定 POST @token_required  /appraisal/api/v1/oa_to_manual
export const oa_to_manual = (data) => {
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v1/oa_to_manual`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSOverallAppraisalAI2ManualRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSOverallAppraisalAI2ManualResponse',
    ERROR_ACTION: 'toast',
    APPRAISERTOKEN_REQUIRED: true,
  })
}

// 鉴定师复核登录 POST @token_required  /appraisal/api/v2/appraiser_login
export const appraiserLogin = (data) => {
  return request({
    url: `${AISERVICE_DOMAIN}/appraisal/api/v2/appraiser_login`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSAppraiserLoginV2Request',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSAppraiserLoginV2Response',
    ERROR_ACTION: 'toast',
    // APPRAISERTOKEN_REQUIRED: true,
  })
}

// 扫码生成中认溯源鉴定报告 POST api/v1/appraisal/source_tracing_hangtagreport
export const scanCodePushReport = (data) => {
  return request({
    url: `${CUSTOMS_DOMAIN}/api/v1/appraisal/source_tracing_hangtagreport`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.SourceTracingReportRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.SourceTracingReportResponse',
    TOKEN_REQUIRED: false,  
    ERROR_ACTION: 'toast',
    httpAddress: 'customs',
  })
}

// 扫码取中认溯源报告 V2 POST api/v1/appraisal/source_tracing_hangtagreport_v2
// 与 V1 的区别：只在已审核时返回数据，未审核回 404「报告尚未生成」；不计访问次数
export const scanCodePushReportV2 = (data) => {
  return request({
    url: `${CUSTOMS_DOMAIN}/api/v1/appraisal/source_tracing_hangtagreport_v2`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.SourceTracingReportV2Request',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.SourceTracingReportV2Response',
    TOKEN_REQUIRED: false,
    ERROR_ACTION: 'none',
    httpAddress: 'customs',
  })
}

// 访问次数 POST api/v1/appraisal/source_tracing_visit_nums
export const addVisitNums = (data) => {
  return request({
    url: `${CUSTOMS_DOMAIN}/api/v1/appraisal/source_tracing_visit_nums`,
    data,
    method:'POST',
  },{
    PB_LOOK_TYPE_PATH_REQUEST: 'client_pb.SourceTracingVisitNumsRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'client_pb.SourceTracingVisitNumsResponse',
    TOKEN_REQUIRED: false,  
    ERROR_ACTION: 'toast',
    httpAddress: 'customs',
  })
}